<template>
  <div class="supermarket-container">
    <TopBar :imgsrc="logo1"/>
    <div class="Bigimg">
      <p class="imgtitle">企业数据资源市场</p>
      <p class="imgcontent">找数据,来这里</p>
    </div>
    <div class="introduce">
      <p class="title">什么是企业数据资源市场?</p>
      <p class="content">企业数据资源市场，是为数据资源提供价值流通的平台，是面向即弃、闲置数据的数商平台(数据资源淘宝)</p>
      <router-link to="/Dataset" class="look">查看数据资源</router-link>
    </div>
    <Serve/>
  </div>
</template>

<script>
import logo1 from "@/assets1/首页_slices (1)/编组 2.png"
import {Login} from '@/api/user'
import { Message } from 'element-ui';
import TopBar from "./TopBar"
import Serve from "./Serve"
export default {
components:{
    TopBar,Serve
},data(){
  return{
    logo1
  }
},
mounted(){
  const that=this
  window.addEventListener('message', async function(event){
    that.$store.commit('setPublic_keyLogin',{
      public_key:event?.data?.data?.public_key,
      nonce:event?.data?.data?.nonce,
      signature:event?.data?.data?.signature
    })
  if(event.origin==='http://127.0.0.1:8080'||event.origin==='http://localhost:8080'){
    return
  }
if(event.data.data.nonce!==null&&event.data.data.nonce!==undefined){
  const res=await Login({
    login_type:2,
    public_key:event?.data?.data?.public_key,
    nonce:event?.data?.data?.nonce,
    signature:event?.data?.data?.signature
  })
  if(res.user){

      that.$store.commit('setUid',res.user.id)   
      that.$store.commit('setUserInfo',res.user)
      console.log(that.$store.state.userInfo,'res.user');
      
 if(res.user.username===""||res.user.company_name===''){
  Message({
          message: `请完善个人信息`,
          type: 'warning'
        });
        that.$router.push('/informationCompletion')
 }else{
  Message({
          message: `登录成功`,
          type: 'success'
        });
        console.log(that.$store,'res');
    
 }
  localStorage.setItem('token',`Bearer ${res.access_token}`)
  sessionStorage.setItem('token',`Bearer ${res.access_token}`)
  }else{
    Message({
          message: `首次登录需要绑定手机号`,
          type: 'warning'
        });
        that.$store.commit('setAuth_token',res.auth_token)
        console.log(that.$store,'aaaaaa');
        
        that.$router.push('/BindPhone')
  }
  console.log(res,'res');
  // that.$store.commit('setUid',res.user.id)   
  // Message({
  //         message: `登录成功${that.$store.state.uid}`,
  //         type: 'success'
  //       });
  //       console.log(that.$store,'res');
    
  // localStorage.setItem('token',`Bearer ${res.access_token}`)
  // sessionStorage.setItem('token',`Bearer ${res.access_token}`)

}
  
  });
},
methods:{

}
}
</script>

<style scoped>
.imgcontent{
  font-size: 24px;
  font-family: Regular;
  line-height: 46px;
}
.imgtitle{
  font-size: 48px;
  font-family: Heavy;
  line-height: 65px;
  margin-bottom: 17px;
}
.look{
  width: 200px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  background-color: #0D53FF;
  border-radius: 12px;
  color: #fff;
  font-family: Regular;
  letter-spacing: 0.5px;
}
.title{
  margin-top: 100px;

  font-size: 36px;
  font-family: Medium;
  margin-bottom: 30px;
}
.content{
  width: 1200px;

  font-family: Regular;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 60px;
  text-align: center;
}
.supermarket-container{
  background-repeat: no-repeat;
  position: relative;
}
.Bigimg{
  min-width: 1920px;
   background-repeat: no-repeat;
  height: 500px;
  background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E9%9B%86%E8%B6%85%E5%B8%82%E4%BB%8B%E7%BB%8D%E9%A1%B5/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%ACbanner%E6%9C%80%E7%BB%88%E7%89%88.png');
  text-align: center;
 background-size: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.introduce{
  min-width: 1920px;
  height: 450px;
  display: flex;
  flex-direction: column;
    align-items: center;
    background-repeat: no-repeat;
      background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E9%9B%86%E8%B6%85%E5%B8%82%E4%BB%8B%E7%BB%8D%E9%A1%B5/%E4%BD%8D%E5%9B%BE.png');
      color: #fff;
       background-size: 100%;
}
</style>